import store from "@store/index";
import {
  addNotification,
  closeNotification,
  removeNotification,
} from "@reducers/UI/NotificationsSlice";
import API from "@api";
import Services from "@services";

const SignIn = async (email: string, password: string): Promise<any> => {
  store.dispatch(
    addNotification({
      key: "signIn",
      message: "Вход в учётную запись...",
      options: { persist: true },
    })
  );

  await API.Auth.signIn(email, password)
    .then(() => {
      store.dispatch(closeNotification("signIn"));
      Services.Auth.LoadUser();
      store.dispatch(
        addNotification({
          message: "Вход успешно выполнен!",
          options: { variant: "success" },
        })
      );
    })
    .catch((error) => {
      store.dispatch(removeNotification("signIn"));
      store.dispatch(
        addNotification({ message: error.response.data.error, options: { variant: "error" } })
      );
      throw new Error(error.response.data.error);
    });
};

export default SignIn;
